<template>
    <div :class="getClasses()" @click="handleChecked">
    </div>
</template>
<script>
    export default {
        name: 'CheckBox',
        props: ['checked'],
        methods: {
            getClasses() {
                return [
                    'select-checkbox',
                    {
                        [`select-checkbox-checked`]: this.checked
                    }
                ]
            },
            handleChecked() {
                this.$emit('input', !this.checked)
                this.$emit('click', !this.checked)
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/business/select-member/tree/checkbox.vue